class CartService {
  
  _loadingPromise = null;

  constructor() {
    this.cart = null;
    this.subscribers = new Set();
  }

  async load() {
    if (this._loadingPromise) return this._loadingPromise;

    this._loadingPromise = fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        this.cart = cart;
        this.notify();
        return cart;
      })
      .finally(() => {
        this._loadingPromise = null;
      });

    return this._loadingPromise;
  }

  async change(variantId, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });

    this.cart = await res.json();
    this.notify();
    this.setCartCount();
    return this.cart;
  }

  setCartCount() {
    const cartCount = document.querySelector("#cartCount");
    cartCount.textContent = this.cart.item_count ?? 0;
  }

  setCart(cart) {
    this.cart = cart;
    this.notify();
  }

  subscribe(fn) {
    this.subscribers.add(fn);
    if (this.cart) fn(this.cart);
  }

  unsubscribe(fn) {
    this.subscribers.delete(fn);
  }

  notify() {
    this.subscribers.forEach(fn => fn(this.cart));
  }
}

window.cartService = new CartService();
